export default __webpack_public_path__ + "img/bg-tab1and2_nav8-dd63f013.png";